import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Typography, Grid, Button, Box } from "@mui/material";
import { Formik, ErrorMessage, Form } from "formik";
import FormikFields from "./FormikFields";
import validationObject from "../../ValidationSchema";
import { toast } from "react-toastify";

// Parent component
const FormikForm = ({
  allFields,
  isEditModel,
  buttonTitle,
  fullScreen,
  content,
  formMethod,
}) => {
  // Construct initial values object
  const [error, setError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [valueObjectForError, setValueObjectForError] = useState(
    buttonTitle[0] === "E"
      ? {
          key1: "",
          key2: "",
          key3: "",
          key4: "",
        }
      : {}
  );
  const [isErrorField, setIsErrorField] = useState(false);
  const initialValues = {};

  allFields?.forEach((field) => {
    initialValues[field?.fieldName] = field?.initialValue;
  });

  useEffect(() => {
    if (error) {
      toast.error("Please fill require fields.");
    }
  }, [error]);

  return (
    <Box>
      <Formik
        initialValues={isEditModel ? initialValues : {}}
        validationSchema={Yup.object(validationObject(Yup, allFields))}
        onSubmit={(values, { setSubmitting }) => {
          // You can handle form submission here
          formMethod(values);
          // After handling submission, you can reset the form
          setSubmitting(false);
        }}
        validate={(values) => {
          Yup.object(validationObject(Yup, allFields))
            .validate(values, { abortEarly: false })
            .then(() => {
              setIsDisabled(false);
            })
            .catch((err) => {
              const newErrors = {};
              err.inner.forEach((error) => {
                newErrors[error.path] = error.message;
              });
              setIsDisabled(true);
            });
          setValueObjectForError(values);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={2}>
              {allFields?.map((field) => (
                <Grid
                  item
                  md={fullScreen || allFields.length === 1 ? 12 : 6}
                  xs={12}
                  key={field.fieldName}
                >
                  <FormikFields
                    fieldLabel={field.fieldLabel}
                    fieldName={field.fieldName}
                    fieldType={field.fieldType}
                    options={field?.options}
                    disabled={field.disabled}
                    isErrorField={isErrorField}
                  />
                  <Typography sx={{ color: "red", fontSize: 14, margin: 1 }}>
                    <ErrorMessage name={field.fieldName} />
                  </Typography>
                </Grid>
              ))}
            </Grid>

            {content && content()}

            <Grid container mt={2}>
              <Grid item md={12} xs={12}>
                <Button
                  variant="contained"
                  type="submit"
                  onClick={() => {
                    var size = Object.keys(valueObjectForError).length;
                    if (size !== allFields.length && !isEditModel) {
                      setError("Please fill require fields.");
                      setIsErrorField(true);
                    } else {
                      setError("");
                      setIsErrorField(false);
                    }
                  }}
                  fullWidth
                  size="large"
                  disabled={isSubmitting || isDisabled}
                >
                  {buttonTitle === "Login" ? buttonTitle : "save"}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
export default FormikForm;
